<template>
  <div :class="[$style.right_bar_wrapper, 'right_bar_history']">
    <div :class="$style.right_bar_header_block">
      <div :class="$style.right_bar_header">
        <div :style="{display: 'flex'}">
          <div :class="$style.header_title">
            {{ locales('history_events') }}
          </div>
          <div :class="$style.filter_button">
            <icon-button
              :class="$style.filter_button_icon"
              :icon="{ name:'filter', size: 24, type: 'regular' }"
              @onClick="$emit('filterClick')"
            />
            <div
              v-if="activeFilter"
              :class="$style.activeFilter"
            />
          </div>
        </div>

        <vgp-input
          ref="input"
          v-model="inputValue"
          :model-value="inputValue"
          :class="$style.header_search"
          :small="true"
          :border="false"
          :icons-left="[{ name: 'search', handler: null }]"
          :icons-right="textInputIconsRight"
          @update:modelValue="() => $emit('search', inputValue)"
        />

        <div
          :class="$style.header_hide_bar"
          @click="$emit('toggleSidebar')"
          @dblclick="$emit('toggleSidebar')"
        >
          <icon-button
            :icon="{ name:'collaps-right', size: 24, type: 'bold' }"
            :colors="colors"
          />
        </div>
      </div>

      <div :class="$style.filter_tabs">
        <vgp-tabs
          :tabs="tabsItems"
          :active="filterButton"
          active-by="type"
          :type="'button'"
          :fixed-width="'86.5px'"
          :disable="!!inputValue.length"
          gp-autotest-name="gp_autotest_history_filter_buttons"
          @onToggle="selectTab"
        />
      </div>
    </div>

    <div :class="$style.right_bar_inner_wrapper">
      <div
        v-if="!searchedEvents"
        ref="fixedHeader"
        :class="[$style.pinned_date, $style.date_title]"
      >
        {{ pinnedDate }}
      </div>
      <div
        v-if="searchedEvents"
        :class="$style.search_stub"
      >
        <svg-image
          :name="stubSvg"
          :width="183"
          :height="183"
        />
        <div :class="$style.search_stub_text">
          {{ locales(stubText) }}
        </div>
      </div>

      <vgp-scroll-bar
        v-else
        ref="scrollContainer"
        :height="height"
        @onScroll="onScroll"
      >
        <div
          v-for="(event, date) in preparedEvents"
          :key="date"
          ref="sections"
          :data-date="date"
        >
          <div
            :ref="date"
            :class="[$style.date_title]"
          >
            {{ date }}
          </div>

          <div
            v-if="filterButton.type === 'all'"
          >
            <div
              v-for="item in event"
              :key="item.id"
            >
              <event-item
                :ref="getRefName(item)"
                :item="item"
                :selected-item="selectedEvent"
                @selectItem="selectedItem"
              />
            </div>
          </div>

          <div v-else>
            <div
              v-for="dateUnit in event"
              :key="dateUnit.id"
            >
              <div
                :class="$style.folder_item"
                @click="selectFolderItem(dateUnit)"
              >
                <div :class="$style.folder_item_name">
                  <svg-sprite
                    :style="{ marginRight: '4px', marginTop: '-2px' }"
                    :name="'project'"
                  />
                  <div>{{ dateUnit.display }}</div>
                </div>
                <div>{{ dateUnit.count }}  {{ locales('history_changes_title') }}</div>
              </div>
            </div>
          </div>
        </div>
      </vgp-scroll-bar>
      <div
        v-if="isShowGradient"
        :class="$style.gradient"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import dateFormatHelper from '../../../helpers/dateFormatsHelper';
import iconButton from '../../common/VueComponents/globalButton/withIcon/iconButton.vue';
import EventItem from './eventItem.vue';
import svgImage from '../../common/VueComponents/VueIcon/vgpSvgImage.vue';
import vgpScrollBar from '../../common/VueComponents/scrollBar/vgpScrollBar.vue';

const __ = window.__;

export default {
  name: 'RightBar',
  components: {
    svgImage,
    EventItem,
    iconButton,
    vgpScrollBar,
  },
  props: {
    events: {
      type: Object,
      default: () => ({ all: {} }),
    },
    activeFilter: {
      type: Boolean,
      required: false,
    },
    preparedPinDate: {
      type: String,
      required: false,
      default: null,
    },
    selectedEvent: {
      type: Object,
      default: null,
    },
  },
  emits: [
    'filterClick',
    'search',
    'toggleSidebar',
    'selectEvent',
  ],
  data() {
    return {
      locales: __,
      colors: {
        color: '#1565C0',
        activeColor: '#11519A',
        hoverBg: '#D0E0F2',
        activeBg: '#A1C1E6',
        activeHoverBg: '#D0E0F2',
      },
      tabsItems: [{
        id: 1,
        title: __('history_All'),
        type: 'all',
      },
      {
        id: 2,
        title: __('history_Hours'),
        type: 'hours',
      },
      {
        id: 3,
        title: __('history_Days'),
        type: 'days',
      }, {
        id: 4,
        title: __('history_Month'),
        type: 'months',
      }],
      filterButton: {
        id: 1,
        title: __('history_All'),
        type: 'all',
      },
      inputValue: '',
      preparedEvents: {},
      stubSvg: 'comment-hub-no-search',
      stubText: 'comment-hub-no-search-global',
      activeTitle: null,
      pinnedDate: '',
      visibleDates: new Set(),
      lastVisibleDate: '',

      isShowGradient: true,
    };
  },
  computed: {

    projectId() {
      return this.$route.params.projectId;
    },
    height() {
      const clientHeight = document.documentElement.clientHeight;

      return `${clientHeight - 110 - 50}px`;
    },

    textInputIconsRight() {
      let icons = [];

      if (this.inputValue !== '') {
        icons = [{ name: 'close-5', type: 'bold', handler: this.resetInputValue }];
      }

      return icons;
    },
    searchedEvents() {
      return this.events.all && Object.keys(this.events.all).length === 0;
    },

  },
  watch: {
    events: {
      handler(val) {
        if (Object.keys(val).length > 0) {
          this.prepareEvents();
        }
      },
      immediate: true,
    },
    preparedPinDate: {
      handler(val) {
        if (val) {
          this.pinnedDate = this.preparedPinDate;
        }
      },
      immediate: true,
    },

  },
  methods: {
    updatePinnedDate() {
      const fixedHeader = this.$refs.fixedHeader;

      if (!fixedHeader) {
        return;
      }

      const headerTop = fixedHeader.getBoundingClientRect().top;

      let closestDate = null;
      let minDiff = Infinity;

      this.$refs.sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;

        const diff = Math.abs(sectionTop - headerTop);

        // Если секция ближе всего к фиксированному заголовку
        if (sectionTop <= headerTop && diff < minDiff) {
          minDiff = diff;
          closestDate = section.dataset.date;
        }
      });

      if (closestDate) {
        this.pinnedDate = closestDate;
      }
    },

    getDateFromEntry(target) {
      for (const date in this.$refs) {
        const section = this.$refs[date];

        if (Array.isArray(section) && section[0] === target) {
          return date;
        }
        if (!Array.isArray(section) && section === target) {
          return date;
        }
      }
    },

    getRefName(item) {
      return `${moment(item.created_at).format('DD-MM-YYYY HH:mm')}`;
    },
    resetInputValue() {
      this.inputValue = '';
      this.$emit('search', this.inputValue);
    },
    getDate(date) {
      return moment(date).calendar(null, {
        sameElse: dateFormatHelper.getUserDateFormat(),
      });
    },
    selectTab(item) {
      this.filterButton = item;
      this.prepareEvents();
    },

    selectedItem(item) {
      this.$emit('selectEvent', item);
    },
    prepareEvents() {
      this.preparedEvents = this.events[this.filterButton.type];
    },

    selectFolderItem(dateUnit, event) {
      const hoursTab = this.filterButton.type === 'hours';

      if (this.filterButton) {
        this.filterButton = {
          id: 1,
          title: __('history_All'),
          type: 'all',
        };
      }

      this.prepareEvents();
      setTimeout(() => {
        this.$nextTick(() => {
          const startWith = hoursTab ? `${dateUnit.id} ${dateUnit.display.split(':')[0]}` : dateUnit.id;
          const matchingRefs = Object.entries(this.$refs)
            .filter(([key]) => key.startsWith(startWith))
            .map(([key, refs]) => refs);

          const firstRef = matchingRefs[0] || null;
          const container = this.$refs.scrollContainer?.$el?.querySelector('.simplebar-content-wrapper');

          if (firstRef) {
            firstRef[0].clickItem();
          }

          if (firstRef && container) {
            const containerRect = container.getBoundingClientRect();
            const elementRect = firstRef[0].$el.getBoundingClientRect();

            container?.scrollTo({
              top: elementRect.top - containerRect.top - 42, // fixed header offset
              behavior: 'smooth',
            });
          }
        });
      }, 500);
    },
    onScroll() {
      this.closeAllTooltips();
      this.updatePinnedDate();
      this.calcShadow();
    },
    calcShadow() {
      const element = this.$refs.scrollContainer?.$el?.querySelector('.simplebar-content-wrapper');

      if (!element) {
        return;
      }

      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      if (scrollTop + clientHeight >= scrollHeight) {
        this.isShowGradient = false;
      } else {
        this.isShowGradient = true;
      }
    },
    closeAllTooltips() {
      const el = document.querySelector('[data-tippy-root]');

      if (el && el._tippy && el._tippy.state?.isVisible) {
        el._tippy.hide();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.right_bar_history {
  :deep(.simplebar-vertical) {
    margin-top: 42px; // space for fixed header
    height: calc(100% - 42px);
  }
}
</style>

<style module lang="less">
@import '../../../less/_fonts.less';
@import '../../../less/_mixins.less';

.header_title {
  color: #191919;
  .FontLatoBold;
  .fs(16px, 26px);
}

.right_bar_wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
}

.right_bar_header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #E5E5E5;
}

.right_bar_inner_wrapper {
  position: relative;
  height: 100%;
}

.right_bar_bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: #fff;
    padding: 12px 0 16px;
}

.header_hide_bar {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.filter_tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px 9px;
}

.header_search {
  height: 33px;
  padding: 1px 8px;

  &:hover {
    background: unset;
  }
}

.date_title {
  height: 42px;
  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: start;
  color: #999;
  letter-spacing: 1px;
  text-transform: uppercase;

  .FontLatoRegular;
  .fs(12px, 18px);
}

.right_bar_header_block{
  display: flex;
  flex-direction: column;
}

.folder_item {
    display: flex;
    padding: 8px 12px;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    font-family: "Lato-Regular", sans-serif;
    font-size: 12px;
    line-height: 15px;
    color: #0D0D0D;
    border-bottom: 1px solid var(--color-shape-separator, #E5E5E5);
    background: #FFF;
    &_name {
        display: flex;
        align-items: center;
    }
    &:hover {
        background-color: #F8F8F8;
    }
}
.search_stub{
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &_text {
      color: #808080;
      .FontLatoBold;
      .fs(12px, 18px);

      margin-top: 32px;
      text-align: center;
    }
}
.pinned_date {
  position: absolute;
  width: 100%;
  height: 42px; // fixed header height
  background: #fff;
  z-index: 9;
}
.date_title {
    transition: all 0.3s ease;
}
.gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
.activeFilter {
    width: 8px;
    height: 8px;
    background:#1565C0;
    border-radius: 50%;
    position: absolute;
    right: 13px;
    top: 2px;
}
.filter_button {
  margin-left: 12px;
  position: relative;

  &_icon {
    --hover-bg: none !important;
    --active-bg: none !important;
  }
}
</style>
